import { render, staticRenderFns } from "./StatesSelect.vue?vue&type=template&id=a2b901f0&scoped=true&"
import script from "./StatesSelect.vue?vue&type=script&lang=js&"
export * from "./StatesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b901f0",
  null
  
)

export default component.exports